import {
  setIsLoading,
  setSuccess,
  setError
} from './heat-pump-registration-slice';
import { addonSignup } from 'api/addon-signup';
import { getErrors } from 'api/client';

export const sendHeatPumpSignupData = (payload) => async (dispatch) => {
  try {
    dispatch(setIsLoading());
    const response = await addonSignup({
      topic: 'heatpump-signup',
      ...payload
    });
    dispatch(setSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
